export const GET_SHOP_CONCEPTS = 'GET_SHOP_CONCEPTS'
export const GET_SHOP_CONCEPTS_SUCCESS = 'GET_SHOP_CONCEPTS_SUCCESS'
export const GET_SHOP_CONCEPTS_FAILED = 'GET_SHOP_CONCEPTS_FAILED'

export const GET_SHOP_CONCEPT = 'GET_SHOP_CONCEPT'
export const GET_SHOP_CONCEPT_SUCCESS = 'GET_SHOP_CONCEPT_SUCCESS'
export const GET_SHOP_CONCEPT_FAILED = 'GET_SHOP_CONCEPT_FAILED'
